import React from "react";
import { Link } from "react-router-dom";
import Image from "../Image";

const ProductMiniItem = ({image, title, url}) => {
  return (
    <div className="project-services">
      <div className="project-services-img">
        <Image className="img-fluid center-block transition" image={image} />
      </div>
      <div className="project-services-content">
        <h5>
          <Link to={url}>{title}</Link>
        </h5>
      </div>
    </div>
  );
};

export default ProductMiniItem;
